export function getOperIdFromUrl(url: string): Nullable<string> {
  try {
    const parsedUrl = new URL(url);
    const operId = parsedUrl.searchParams.get('oper_id');
    return operId;
  } catch (error) {
    console.error('Некорректний URL:', error);
    return null;
  }
}
